<template>
  <b-card>
    <div class="d-flex mb-2">
      <b-button
        size="sm"
        variant="exitos"
        @click="addContrapartida(null, true)"
      >
        <font-awesome-icon icon="plus" />
        Adicionar Modelo de Contrapartida
      </b-button>
      <div class="mr-auto"></div>
      <div>
        <b-button size="sm" variant="exitos" @click="addContrapartida()">
          <font-awesome-icon icon="plus" />
          Adicionar Contrapartida
        </b-button>
      </div>
    </div>

    <b-table
      responsive
      striped
      hover
      show-empty
      :items="oportunidade.contrapartidas"
      :fields="fields"
      :currentPage="pagination.currentPage"
      :perPage="pagination.perPage"
    >
      <template #cell(descricao)="{ item }">
        <div class="limit-text limit-text-3-lines">
          {{ item.descricao }}
        </div>
      </template>

      <template #cell(actions)="row">
        <Actions
          :item="row.item"
          :view_show="false"
          :view_edit="!row.item.modelo_id"
          :edit_to="null"
          @edit="addContrapartida(row.index)"
          @delete="deleteContrapartida(row.index)"
        />
      </template>

      <template #empty="{}">
        <h5 class="text-center">Nenhum item cadastrado</h5>
      </template>
    </b-table>

    <b-row class="mt-4">
      <b-col>
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="oportunidade.contrapartidas.length"
          :per-page="pagination.perPage"
          size="sm"
        ></b-pagination>
      </b-col>

      <b-col>
        <b-form-group
          label="Exibir"
          label-cols="8"
          label-align="right"
          label-size="sm"
        >
          <b-form-select
            v-model="pagination.perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-modal
      title="Dados da Contrapartida"
      id="modal-contrapartida"
      ref="modal-contrapartida"
      size="lg"
      ok-variant="exitos"
      @ok="saveContrapartida"
      @hidden="resetEdit"
    >
      <form-contrapartidas
        :value="contrapartida_edit"
        :select_modelos="show_modelos"
        @selectedModelo="saveContrapartida"
        ref="form-contrapartida"
      />
    </b-modal>
  </b-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Actions from "@/components/Table/Actions.vue";
import FormContrapartidas from "./FormContrapartidas.vue";
import _ from "lodash";

export default {
  components: {
    Actions,
    FormContrapartidas,
  },
  data: () => ({
    contrapartida_index: null,
    contrapartida_edit: null,
    pagination: {
      currentPage: 1,
      perPage: 10,
    },
    pageOptions: [5, 10, 15, 50],
    show_modelos: false,
  }),
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    ...mapGetters("oportunidades", ["tipos_contrapartida"]),
    fields() {
      return [
        {
          key: "tipo_contrapartida",
          label: "Tipo",
          class: "col-2",
          formatter: (value, head, object) => {
            let response = _.find(this.tipos_contrapartida, { value: value });
            return response ? response.text : "";
          },
        },
        { key: "descricao", label: "Descrição" },
        {
          key: "minima",
          label: "Min",
          class: "col-2",
          formatter: (value, head, object) => {
            if (!object.unidade) {
              return "--";
            }

            const format = object.unidade == "%" ? "0,000.0" : "0,000.00";
            return (
              this.$options.filters.number_format(value, format) +
              " (" +
              object.unidade +
              ")"
            );
          },
        },
        {
          key: "maxima",
          label: "Max",
          class: "col-2",
          formatter: (value, head, object) => {
            if (!object.unidade) {
              return "--";
            }
            const format = object.unidade == "%" ? "0,000.0" : "0,000.00";
            return (
              this.$options.filters.number_format(value, format) +
              " (" +
              object.unidade +
              ")"
            );
          },
        },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    addContrapartida(index = null, show_modelos = false) {
      if (index !== null) {
        this.contrapartida_index = index;
        this.contrapartida_edit = this.oportunidade.contrapartidas[index];
      } else {
        this.contrapartida_index = null;
        this.contrapartida_edit = null;
      }
      this.show_modelos = show_modelos;
      this.$bvModal.show("modal-contrapartida");
    },
    deleteContrapartida(index) {
      this.oportunidade.contrapartidas.splice(index, 1);
    },
    async saveContrapartida(evt) {
      evt ? evt.preventDefault() : null;

      if (this.show_modelos) {
        let selecionados = this.$refs["form-contrapartida"].getSelecionados();

        selecionados.forEach((contrapartida) => {
          contrapartida.modelo_id = contrapartida.id;
          contrapartida.id = null;
          this.oportunidade.contrapartidas.push(contrapartida);
        });

        this.$nextTick(() => {
          this.$bvModal.hide("modal-contrapartida");
        });
        return;
      }
      let contrapartida = await this.$refs["form-contrapartida"].save();

      if (contrapartida) {
        if (this.contrapartida_index !== null) {
          let contrapartidas = JSON.parse(
            JSON.stringify(this.oportunidade.contrapartidas)
          );
          contrapartidas[this.contrapartida_index] = contrapartida;
          this.oportunidade.contrapartidas = contrapartidas;
        } else {
          this.oportunidade.contrapartidas.push(contrapartida);
        }

        this.$nextTick(() => {
          this.$bvModal.hide("modal-contrapartida");
        });
      }
    },
    resetEdit() {
      this.contrapartida_index = null;
      this.contrapartida_edit = null;
    },
  },
  filters: {
    tipo_contrapartida: function (value) {
      let response = "";

      return response;
    },
  },
};
</script>

<style lang="scss">
.list-contrapartidas {
  .handle {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  .td-item {
    padding-top: 0.3rem;
    padding-bottom: 0;
  }
}
</style>
